import Button from "components/common/buttons/buttons";
import { FixedButtonContainer } from "components/common/buttons/FixedButtons";
import TopHeader from "components/common/header";
import { Forward } from "components/common/Icons";
import { SurveyTitle } from "components/templates/common/SAA/util/component";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { TYPO } from "styles/Typo";
import Head from "next/head";
import { usePlannerFlow } from "lib/analytics/react/hooks";
import { getPublicAssetUrl } from "utils/objectStorage";

const MetaHead = () => {
  return (
    <Head>
      <link rel="Icon" href="/images/favicon.png" type="image/x-icon" />
      <title>{"리스크웨더 투자 플래너 | Riskweather"}</title>
      <meta
        property="og:image"
        content={getPublicAssetUrl(`meta/plannerMeta.png`)}
        key="og:image"
      />
      <meta
        property="og:description"
        content={"돈 나가는 날까지 매달 불려드려요"}
        key="og:description"
      />

      <meta name="description" content={`돈 나가는 날까지 매달 불려드려요`} />
      <meta
        property="og:title"
        content={"리스크웨더 투자 플래너"}
        key="og:title"
      />
      <meta name="twitter:title" content={"리스크웨더 투자 플래너"} />
      <meta
        name="twitter:description"
        content={"돈 나가는 날까지 매달 불려드려요"}
      />
      <meta
        name="twitter:image"
        content={`https://riskweather.io/images/DetailThumb.png`}
      />
      <meta name="twitter:card" content={`summary`} />
    </Head>
  );
};

export default function SaaNew({ isMobile }: { isMobile: boolean }) {
  const router = useRouter();
  const plannerFlow = usePlannerFlow();

  return (
    <main
      className="min-w-[360px] max-w-[800px] w-screen bg-bg "
      style={{
        minHeight: isMobile ? "100dvh" : "calc(100vh - 80px)",
      }}
    >
      <MetaHead />
      <TopHeader
        clickHandler={() => {
          router.push("/");
        }}
      />
      <div className="px-6 pt-6  flex flex-col gap-1 ">
        <p
          className={`text-[26px] font-[600] whitespace-pre-line test-gray90 leading-[40px]`}
        >{`큰 돈 나갈 일\n오늘부터 준비하세요`}</p>
      </div>
      <div className="h-6" />
      <div className="py-5 flex items-center justify-center">
        <Image
          src="/images/saanew.png"
          alt="coffee"
          width={160}
          height={160}
          className="w-[160px] h-[160px]"
        />
      </div>
      <div className="h-6" />
      <div className="pb-[110px]">
        <div className="py-3">
          <div className="flex items-start gap-3 px-6 py-1">
            <p
              className={`${TYPO.TYPO7_MD} text-gray70 bg-grayOpacity10 rounded-full w-[26px] h-[26px] flex items-center justify-center`}
            >
              1
            </p>
            <div>
              <p className={`${TYPO.TYPO5_1_SB} text-gray80`}>
                내 목돈 입력하면
              </p>
              <p className={`${TYPO.TYPO7_1_RG} text-gray60`}>
                지금까지 모은 돈과 매달 들어오는 돈
              </p>
            </div>
          </div>

          <div className="px-6">
            <div className="flex items-center justify-center  w-[30px] h-[30px]">
              <div className="h-5 w-[2px] bg-hairlineBorder rounded-[10px]" />
            </div>
          </div>
          <div className="flex  gap-3 px-6 py-1">
            <p
              className={`${TYPO.TYPO7_MD} text-gray70 bg-grayOpacity10 rounded-full w-[26px] h-[26px] flex items-center justify-center`}
            >
              2
            </p>

            <div>
              <p className={`${TYPO.TYPO5_1_SB} text-gray80`}>
                이곳저곳 골고루 나눠서
              </p>
              <p className={`${TYPO.TYPO7_1_RG} text-gray60`}>
                주식, 채권, 금, 현금
              </p>
            </div>
          </div>

          <div className="px-6">
            <div className="flex items-center justify-center  w-[30px] h-[30px]">
              <div className="h-5 w-[2px] bg-hairlineBorder rounded-[10px]" />
            </div>
          </div>
          <div className="flex items-start gap-3 px-6 py-1">
            <p
              className={`${TYPO.TYPO7_MD} text-gray70 bg-grayOpacity10 rounded-full w-[26px] h-[26px] flex items-center justify-center`}
            >
              3
            </p>
            <div>
              <p className={`${TYPO.TYPO5_1_SB} `}>
                <span className="!text-blue50">
                  돈 나가는 날까지 매달 불려드려요
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <FixedButtonContainer isMobile={isMobile} customStyle={{ zIndex: 21 }}>
        <Button
          size="xl"
          text="10초만에 설계 받기"
          type="primary"
          btnClass="w-full"
          clickHandler={() => {
            plannerFlow.start();
            router.push(`/saa/category`);
          }}
          dataGtmId="saa-landing-start-btn"
        />
      </FixedButtonContainer>
    </main>
  );
}
